import React from 'react';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import { SVG, Icons } from '../../../atoms/SVG';
import bem from '../../../../lib/bemUtils/bem';
import { appendClassNames } from '../../../../lib/bemUtils/classname';

export enum FilterButtonModifier {
  SELECT_A_LOT = 'select-a-lot',
}

export type FilterButtonProps = {
  title: string;
  value?: React.ReactNode;
  isActive?: boolean;
  buttonClassName?: string;
  modifier?: Modifier<FilterButtonModifier>;
  buttonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
};

export function FilterButton({ title, value, isActive, buttonClassName, modifier, buttonProps }: FilterButtonProps) {
  const buttonClasses = appendClassNames(
    bem('filter-button__button', modifier),
    isActive ? 'filter-button__button--active' : '',
    buttonClassName || ''
  );

  return (
    <button type="button" className={buttonClasses} {...buttonProps}>
      <span className="filter-button__title-container">
        <span className="filter-button__title">
          {title}
          {value ? ': ' : ''}
        </span>
        {value ? <span className="filter-button__value">{value}</span> : null}
      </span>
      <span className="filter-button__icon-container">
        <SVG svgSpriteId={Icons.ARROW_DOWN} />
      </span>
    </button>
  );
}
